import * as React from "react";
import type { DormantIntegration } from "src/scenes/dashboard/types";
import { useActiveIntegrations } from "./active-integrations-provider";
import request from "../../utils/request";
import CentrallyManagedModal from "./centrally-managed-modal";

const CentrallyManaged = () => {
    const { activeIntegrations } = useActiveIntegrations();
    const [accounts, setAccounts] = React.useState([] as DormantIntegration[]);
    const [modalOpen, setModalOpen] = React.useState(true);

    const STORAGE_NAME = "dormSelfLab";

    React.useEffect(() => {
        const getDormant = async () => {
            const value = localStorage.getItem(STORAGE_NAME);
            if (!value) {
                const dormant = await request<undefined | DormantIntegration[]>(
                    "api/users/me/dormant-integrations"
                );
                if (dormant && dormant.length > 0) setAccounts(dormant);
            }
        };
        if (activeIntegrations.data && activeIntegrations.data.integrations) {
            const centrallyManaged = activeIntegrations.data.integrations.find(
                (integration) => !integration.connected && integration.centrallyManaged
            );
            if (centrallyManaged) {
                getDormant();
            }
        }
    }, [activeIntegrations.data && activeIntegrations.data.integrations]);

    if (!accounts || accounts.length === 0) return null;

    return (
        <CentrallyManagedModal
            open={modalOpen}
            handleClose={() => setModalOpen(false)}
            accounts={accounts}
        />
    );
};

export default CentrallyManaged;
